import { client } from './utils';

export const login = (username, password, device) =>
    client.post('/auth/login', { username, password, device });

export const profile = () => client.get('/auth/profile');

export const refresh = () => client.post('/auth/refresh');

export const logout = () => client.post('/auth/logout');